export default {"src":"/_next/static/media/pricing.199ceb9a.svg","height":121,"width":120};